module.exports = __webpack_public_path__ + "media/topSection/4-51a7fb75.png";